// The name a peak row shows.
//
// OSM spot heights carry no name, and bag detection still counts them (only a
// route's "Peaks on this route" drops them), so a walker's bags can include a
// peak whose `name` is null or blank. Rendering that raw left a row with a date
// and a height but no title.
//
// Twins: Android `modules/myPeaks/models/PeakDisplayName.kt` and iOS
// `Modules/MyPeaks/Models/PeakDisplayName.swift`.

/** The localized fallback: 'Unnamed peak 565 m', or plain 'Unnamed peak' with no height either. */
export interface UnnamedPeakLabels {
  plain: string
  withHeight: (height: string) => string
}

/** `name` trimmed, or the fallback carrying `elevation` (already formatted, e.g. '565 m'). */
export function resolvePeakDisplayName (
  name: string | null | undefined,
  elevation: string | null | undefined,
  labels: UnnamedPeakLabels
): string {
  const trimmed = (name || '').trim()
  if (trimmed) return trimmed
  const height = (elevation || '').trim()
  return height ? labels.withHeight(height) : labels.plain
}
